"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInternalUserTitle = exports.StyledInternalUserName = exports.StyledInternalUserLink = exports.StyledInternalUserItemContainer = exports.StyledInternalUserHeader = exports.StyledInternalUserGlobalStyle = exports.StyledInternalUserContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledInternalUserGlobalStyle = (0, _styledComponents.createGlobalStyle)(["header{margin-top:50px;}"]);
exports.StyledInternalUserGlobalStyle = StyledInternalUserGlobalStyle;

var StyledInternalUserHeader = _styledComponents["default"].div.withConfig({
  displayName: "InternalUserHeaderstyles__StyledInternalUserHeader",
  componentId: "sc-ms9eti-0"
})(["", " -webkit-justify-content:flex-end;justify-content:flex-end;z-index:9060;font-family:Helvetica,Arial,'Arial Narrow';"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["bg-yellow flex fixed w-100 top-0 pa2 left-0 center"]))));

exports.StyledInternalUserHeader = StyledInternalUserHeader;

var StyledInternalUserContainer = _styledComponents["default"].div.withConfig({
  displayName: "InternalUserHeaderstyles__StyledInternalUserContainer",
  componentId: "sc-ms9eti-1"
})(["", " max-height:32px;min-width:150px;"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["dib self-center mh2"]))));

exports.StyledInternalUserContainer = StyledInternalUserContainer;

var StyledInternalUserItemContainer = _styledComponents["default"].div.withConfig({
  displayName: "InternalUserHeaderstyles__StyledInternalUserItemContainer",
  componentId: "sc-ms9eti-2"
})(["", ""], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["dib self-center v-mid"]))));

exports.StyledInternalUserItemContainer = StyledInternalUserItemContainer;

var StyledInternalUserName = _styledComponents["default"].span.withConfig({
  displayName: "InternalUserHeaderstyles__StyledInternalUserName",
  componentId: "sc-ms9eti-3"
})(["", " font-size:14px;"], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["db ml1 fw7"]))));

exports.StyledInternalUserName = StyledInternalUserName;

var StyledInternalUserTitle = _styledComponents["default"].span.withConfig({
  displayName: "InternalUserHeaderstyles__StyledInternalUserTitle",
  componentId: "sc-ms9eti-4"
})(["", ""], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["db f7"]))));

exports.StyledInternalUserTitle = StyledInternalUserTitle;

var StyledInternalUserLink = _styledComponents["default"].a.withConfig({
  displayName: "InternalUserHeaderstyles__StyledInternalUserLink",
  componentId: "sc-ms9eti-5"
})(["", ""], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["dib black no-underline black ph4 f7 fw4 ttn bw0 bg-transparent"]))));

exports.StyledInternalUserLink = StyledInternalUserLink;